import {
  brandSpecificStaticText,
  staticText,
  Translated,
} from '../../utils/translations/staticText';

// TI sticky-footer copy (CMS-1643), block-local per the cms-blocks i18n
// convention (cf. PlanTierSelector/TiProviderHero) — these keys are used only
// by StickyFooterCta. Default (`_`) serves SingSaver (EN; no ZH locale);
// MoneyHero overlays ZH-HK on the same defaults and only overrides
// `ti_supporting_e2e` (its brand name differs). The click-out wording is
// brand-neutral (uses the `:provider-name` anchor), so it inherits the default
// for MoneyHero.
export const TRANSLATIONS = brandSpecificStaticText({
  _: staticText({
    ti_supporting_e2e: {
      _: 'Complete your purchase directly on SingSaver.',
      zh: '在SingSaver的網站完成投保',
    },
    ti_supporting_click_out: {
      _: "You will be securely redirected to :provider-name's official site to complete your purchase.",
      zh: '在 :provider-name 的官方網站完成投保。',
    },
  }),
  moneyhero: staticText({
    ti_supporting_e2e: {
      _: 'Complete your purchase directly on MoneyHero.',
      zh: '在MoneyHero的網站完成投保',
    },
  }),
});

export type StaticText = Translated<typeof TRANSLATIONS>;
